(ns manage.script-table.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Switch$default" :as Switch]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            ["src/svg/inform/plus.svg$default" :as Plus]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.script :as script.q]
            [common.util :refer [format-iso-string]]
            [common.widgets.data-grid :as dg]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui status-cell [{disabled :value script :row}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        checked (not (boolean disabled))
        {patch-script :mutate} (use-mutation (script.q/patch-script-mutation
                                              {:advertiser-id advertiser-id
                                               :pixel-id (:id script)}))]
    ($ Stack
       {:direction "row"
        :gap 1
        :alignItems "center"}
       ($ Switch
          {:checked checked
           :onChange #(patch-script {:disabled checked})
           :onClick #(.stopPropagation %)})
       ($ :span (if checked "Enabled" "Disabled")))))

(def columns
  #js [#js {:field "name"
            :headerName "Name"
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:name row))}
       #js {:field "lastModified"
            :headerName "Last modified"
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (format-iso-string (:updated-at row)))}
       #js {:field "disabled"
            :headerName "Status"
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:disabled row))
            :renderCell (dg/get-cell-renderer status-cell)}])

(def Toolbar
  (uix/as-react
   (fn [{:keys [can-create-script?]}]
     ($ dg/grid-toolbar
        ($ Button
           {:onClick #(rf/dispatch [:ocp/open {:id :script/crud}])
            :disabled (not can-create-script?)
            :variant "contained"
            :data-testid "create-script-button"
            :startIcon ($ Plus)}
           "New script")))))

(defn- get-row-id [row]
  (:id row))

(defn- on-row-click [^js params]
  (let [script (.-row params)]
    (rf/dispatch [:ocp/open {:id :script/crud
                             :props {:script script}}])))

(defui scripts-data-grid []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {scripts :data isPending :isPending} (use-query (script.q/scripts-query {:advertiser-id advertiser-id}))

        can-create-script? (< (count scripts) 5)]
    ($ DataGridPremium
       {:columns columns
        :loading isPending

        :rows (to-array scripts)
        :getRowId get-row-id
        :onRowClick on-row-click
        :disableRowSelectionOnClick true

        :slots #js {:toolbar Toolbar}
        :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                        :toolbar #js {:can-create-script? can-create-script?}}

        :localeText #js {:noRowsLabel "No scripts have been created"}
        :initialState #js {:sorting #js {:sortModel #js [#js {:field "lastModified" :sort "desc"}]}}
        :sx #js {:maxHeight "70rem"}})))
